export function objectToFormData(obj) {
    const formData = new FormData();
    for (const [key, value] of Object.entries(obj)) {
        if (value instanceof Blob || typeof value === 'string') {
            formData.append(key, value);
        }
        else if (value instanceof Date) {
            formData.append(key, value.toISOString());
        }
        else {
            formData.append(key, JSON.stringify(value));
        }
    }
    return formData;
}
//# sourceMappingURL=objectToFormData.js.map